import { useState, useRef } from "react";
import { ListItemIcon } from "@remo-co/ui-core/src/components/ListItemIcon";
import { MenuItem } from "@remo-co/ui-core/src/components/MenuItem";
import { LinkIcon } from "@remo-co/ui-core/src/icons/Link";
import useNotificationActions from "modules/notification/hooks/useNotificationActions";
import { getInviteUrl } from "helpers/urlHelper";
import { useI18n } from "i18n";
import logger from "logging/logger";
import { IEvent } from "../../../types";

interface Props {
  event: IEvent;
  className?: string;
  disabled?: boolean;
}

const InviteLink = ({ event, className, disabled }: Props): JSX.Element => {
  const { addErrorNotification, addSuccessNotification } =
    useNotificationActions();
  const menuRef = useRef<HTMLTextAreaElement | null>(null);
  const { t } = useI18n(["common", "event"]);
  const [inviteLink, setInviteLink] = useState("");
  const getInviteLink = async () => {
    if (!inviteLink) {
      // TODO: rework getInviteUrl to accept code and company
      const inviteUrl = await getInviteUrl(event);

      if (inviteUrl && menuRef?.current) {
        menuRef.current.value = inviteUrl;
        setInviteLink(inviteUrl);
      } else {
        logger.error(
          "[EventListItem][handleCopyInviteUrl] Error getting invite url.",
          { inviteUrl },
        );
        addErrorNotification({
          message: t("event:try.later"),
          autoDismiss: 5,
        });
      }
    }
  };

  const handleCopyInviteUrl = async () => {
    await getInviteLink();
    const copyText = menuRef.current;

    copyText?.focus();
    copyText?.select();
    document.execCommand("copy");
    addSuccessNotification({
      message: t("event:copied.link"),
      autoDismiss: 3,
    });
  };

  return (
    <MenuItem
      onClick={handleCopyInviteUrl}
      className={className}
      disabled={disabled}
    >
      <ListItemIcon>
        <LinkIcon fontSize="small" color="secondary" />
      </ListItemIcon>
      {t("event:invite.url")}
      <textarea
        ref={menuRef}
        style={{
          width: 0,
          height: 0,
          padding: 0,
          background: "transparent",
          outline: "none",
          borderColor: "transparent",
        }}
      />
    </MenuItem>
  );
};

export default InviteLink;
